import React from 'react';
import b_ from 'b_';
import cn from 'classnames';
import { SupportPublicationsListItem } from '../SupportPublicationsListItem';
import './styles.scss';

const b = b_.lock('SupportPublicationsList');

export const SupportPublicationsList = ({
  className,
  items = []
}) => (
  <div className={cn(b(), className)}>
    <div className={b('inner')}>
      {items.map(({
        code,
        ...item
      }) => (
        <SupportPublicationsListItem
          className={b('item')}
          key={code}
          sizes='(min-width: 1150px) 320px, (min-width: 640px) 320px, calc(100vw - 20px)'
          {...item}
        />
      ))}
    </div>
  </div>
);
